import React from 'react';
import { useTranslation } from 'react-i18next';

export const TasksTableHeader: React.FC = () => {
  const { t } = useTranslation('goals');

  return (
    <div className="bg-gray-50 border-b border-gray-200 px-4 py-2.5">
      <div className="grid grid-cols-12 gap-3 items-center text-xs font-medium text-gray-600">
        <div className="col-span-2 text-center">
          {t('tasksTable.headerStatus')}
        </div>
        <div className="col-span-4">{t('tasksTable.headerTask')}</div>
        <div className="col-span-2 text-center">
          {t('tasksTable.headerAssignees')}
        </div>
        <div className="col-span-1 text-center">
          {t('tasksTable.headerStartDate')}
        </div>
        <div className="col-span-1 text-center">
          {t('tasksTable.headerDueDate')}
        </div>
        <div className="col-span-1 text-center">
          {t('tasksTable.headerFinishDate')}
        </div>
        <div className="col-span-1 text-center">
          {t('tasksTable.headerActions')}
        </div>
      </div>
    </div>
  );
};
